export const getAccessToken = () => {
  if (typeof window === "undefined") {
    return null;
  }
  const token = localStorage.getItem("okta-anonymous-access-token");
  if (token) {
    return { token };
  }
};

export const getRequiredSpecification = (
  attr = [],
  toMatch = "",
  matchIndex = 0,
  fetchIndex = 0
) => {
  return attr
    .map(s => s.split("|"))
    .find(parts => parts[matchIndex] === toMatch)?.[fetchIndex];
};

export const getRequiredPrice = (
  attr = [],
  toMatch = "",
  matchIndex = 0,
  fetchIndex = 0
) => {
  return attr
    .map(s => s.split("|"))
    .find(parts => parts[matchIndex] === toMatch)?.[fetchIndex];
};

export const vietnameseMonths = [
  "tháng Giêng",
  "tháng hai",
  "tháng ba",
  "tháng tư",
  "tháng năm",
  "tháng sáu",
  "tháng bảy",
  "tháng tám",
  "tháng chín",
  "tháng mười",
  "tháng mười một",
  "tháng mười hai",
];

export const getFormattedDate = (locale, d) => {
  const date = new Date(d);
  if (locale === "vn") {
    const month = vietnameseMonths[date.getMonth()];
    return `${month}, ${date.getFullYear()}`;
  }
  const month = date.toLocaleString("default", { month: "long" });
  return `${month} ${date.getDate()}, ${date.getFullYear()}`;
};

export const getLinkTarget = url => {
  const isExternal = url?.startsWith("http");

  return isExternal ? "_blank" : "_self";
};

export const getLinkTargetTab = tabinfo => {
  return tabinfo === "New Tab" ? "_blank" : "_self";
};

export const hideContentforLocale = (locale, hideContentOn) => {
  let hideContent = false;
  const countryCode = process.env.NEXT_PUBLIC_DEFAULT_LOCALE;

  switch (locale) {
    case countryCode:
      hideContent = hideContentOn === countryCode ? true : false;
      break;

    case "en":
      hideContent = hideContentOn === "en" ? true : false;
      break;

    default:
      hideContent = false;
  }
  return hideContent;
};

export const scrollToTop = div => {
  document.querySelector(`.${div}`)?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};

export default function toCapitalizedCase(text) {
  return text.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
}

export const getLocalizedValue = (storeObject, fieldName, locale = "en") => {
  const isEnglish = locale?.startsWith("en");
  return isEnglish
    ? storeObject?.[fieldName]
    : storeObject?.[`${fieldName}Alternate`] || storeObject?.[fieldName];
};
export const openPopup = (e, url) => {
  e.preventDefault();
  // Specifying width and height forces a popup window instead of a tab
  window.open(
    url,
    "popupWindow",
    "width=1000,height=600,scrollbars=yes,location=yes,status=yes"
  );
};

export const getLocaleKey = (label, localeText) => {
  return Object.keys(localeText || {}).find(key => localeText[key] === label);
};

export const getLocaleClass = (label, locale, localeText, defaultLocale) => {
  const localeKey = getLocaleKey(label, localeText);

  const normalizedLocale = locale?.toUpperCase();
  const normalizedLabel = label?.toUpperCase();

  const isSelected =
    (normalizedLocale === "EN" && normalizedLabel === "EN") ||
    (normalizedLocale === "DEFAULT" && localeKey === defaultLocale);

  return isSelected ? "selected-locale-color" : "locale-color";
};

export const escapeHtml = (str = "") =>
  String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const getDefaultLang = () => {
  const supportedLocales = process.env.NEXT_PUBLIC_SUPPORTED_LOCALES;
  let isNotEnglishDefaulLang = false;
  if (supportedLocales) {
    isNotEnglishDefaulLang = supportedLocales.split(",")?.length > 2;
  }
  return isNotEnglishDefaulLang;
};

export const getPrefixLocale = (
  locale = "",
  isTrailingSlash = true,
  returnLocale = false
) => {
  const isNotEnglishDefaulLang = getDefaultLang();
  if (isNotEnglishDefaulLang && locale === "en")
    return `/${locale}${isTrailingSlash ? "/" : ""}`;

  return returnLocale
    ? `/${locale}${isTrailingSlash ? "/" : ""}`
    : isTrailingSlash
      ? "/"
      : "";
};
